import React from 'react';
import { Card } from 'antd';
import { makeStyles } from '@material-ui/core/styles';
import user01Img from '../assets/hanqiang.png';
import user02Img from '../assets/zhangxuliang.png';
import user03Img from '../assets/linxijian.png';
import user04Img from '../assets/yandongsheng.png';
import user05Img from '../assets/chenjingru.png';
import user06Img from '../assets/zhaoyingying.png';
import user07Img from '../assets/jiaxiaomei.png';
import user08Img from '../assets/wangranran.png';
import { MENU } from '../constants/index';

const { Meta } = Card;

type CardType = {
  name: string;
  img: string;
  title: string;
  info: string;
}

const cardData: CardType[] = [
  {
    name: '韩强',
    img: user01Img,
    title: '',
    info: '资深专利代理师，精通电子通信领域专利布局与疑难案件处理。擅长带领专业团队进行高质量批量申请与案件质控，以卓越的专业能力和管理效能，确保客户获得最优知识产权解决方案与坚实保障。'
  },
  {
    name: '张旭亮',
    img: user02Img,
    title: '',
    info: '以撰写高质量申请文件见长。深耕机械与电学领域，精通权利要求布局，善于为客户争取最大保护范围，案件授权率高且权利稳定性强。'
  },
  {
    name: '林栖剑',
    img: user03Img,
    title: '',
    info: '以精湛的专业能力确保每一案授权率高、权利稳定更以极致服务体验为本，提供高效响应、透明沟通与全程省心的托管服务，是您技术创新的可靠守护者。'
  },
  {
    name: '闫东升',
    img: user04Img,
    title: '',
    info: '兼具技术专家与法律顾问双重角色。精通前沿技术解读与专利布局，善于撰写授权率高、权利稳定的高质量申请文件，是客户值得信赖的专业智囊。'
  },
  {
    name: '陈静如',
    img: user05Img,
    title: '',
    info: '擅长从企业战略出发，构建知识产权与项目申报的整体蓝图。主导制定专利商标布局、高企/专精特新电报规划，提升企业核心竞争力与政策红利获得感。'
  },
  {
    name: '赵颖颖',
    img: user06Img,
    title: '',
    info: '精通知识产权全领域政策与高新技术企业认定标准。精于洞察企业核心需求，提供精准的代理申报路径规划与解决方案，为企业创新布局提供权威决策支持。'
  },
  {
    name: '贾晓美',
    img: user07Img,
    title: '',
    info: '专注于知识产权的后期维护、风险监控与资产运营。提供高企资质维护、专利年费监控、品牌增值等一刘式托管服务，确保知识产权持续生效与价值转化。'
  },
  {
    name: '王冉冉',
    img: user08Img,
    title: '',
    info: '资深商标及版权顾问，深耕知识产权领域。擅长商标注册、版权保护、侵权维权等全流程服务，为企业与个人筑牢创意防线，规避法律风险，让智慧成果得到周全守护。'
  }
];

const useStyles = makeStyles(() => ({
  team: {
    padding: '42px 50px',
    background: '#fff',
    '& h1': {
      fontSize: 42,
      textAlign: 'center'
    },
    '& > div': {
      paddingTop: 56,
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: 20
    },
    '@media (max-width: 1260px)': {
      padding: '42px 0px',
      '& > div': {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
    }
  },
  btn: {
    display: 'flex !important',
    justifyContent: 'center',
    '& button': {
      width: 128,
      height: 40,
      color: '#9595cc',
      background: '#fff',
      border: '1px solid #9595cc',
      cursor: 'pointer',
      '&:hover': {
        background: '#fffafa'
      }
    }
  }
}));

const cardUseStyles = makeStyles(() => ({
  card: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    '& .ant-card-meta-description': {
      minHeight: 132
    },
    '@media (max-width: 1260px)': {
      '& + &': {
        marginLeft: 0
      },
    }
  },
}));

const CardComponent: React.FC<{ data: CardType }> = ({ data }) => {
  const classes = cardUseStyles();

  return (
    <div className={classes.card}>
      <Card cover={<img alt='' src={data.img} />}
      >
        <Meta title={data.name} description={`${data.info}`} />
      </Card>
    </div>
  );
};

const TeamComponent: React.FC<{ setMenu: React.Dispatch<React.SetStateAction<string>> }> = ({ setMenu }) => {
  const classes = useStyles();

  return (
    <div className={classes.team}>
      <h1>团队代表</h1>
      <div>
        { cardData.map((data, index) => <CardComponent key={`card${index}`} data={data} />) }
      </div>
      <div className={classes.btn}>
        <button onClick={() => setMenu?.(MENU.consult)}>联系我们</button>
      </div>
    </div>
  );
}

export default TeamComponent;